<template>
<div class="wrapper">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
     <el-tab-pane label="基本信息" name="first">
      <base-info></base-info>
    </el-tab-pane>
    <el-tab-pane label="员工信息" name="second">
      <staff-list></staff-list>
    </el-tab-pane>
    <el-tab-pane label="核心服务" name="third">
      <core-serve></core-serve>
    </el-tab-pane>
    <el-tab-pane label="服务记录" name="fourth">
      <serve-records></serve-records>
    </el-tab-pane>
    <el-tab-pane label="服务对象" name="five">
      <serve-person></serve-person>
    </el-tab-pane>
  </el-tabs>
</div>
</template>
<script>
import baseInfo from './components/baseInfo.vue'
import staffList from './components/staffList.vue'
import coreServe from './components/coreServe.vue'
import serveRecords from './components/serveRecords.vue'
import servePerson from './components/servePerson.vue'

export default {
  name: 'Detail',
  components: {baseInfo, staffList ,coreServe,serveRecords,servePerson},
  data() {
    return {
      activeName: 'first'
    }
  },
  computed: {
  },
  created() {

  },
  methods: {
    handleClick(){}
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 10px;
  overflow-y: auto;
  .m-content{
    .mc-item{
      line-height: 30px;
      span{
        display: inline-block;
        width: 150px;
        text-align: right;
      }
    }
  }
  h4 {
    height: 40px;
    line-height: 40px;
    color: #333;
    padding-left: 20px;
    margin-bottom: 20px;
  }
}
</style>
